import HelperServices from '../services/CommonServices'
import { Constants } from '../data/Constants';

export const AUTHENTICATE = 'AUTHENTICATE';

export const LOGIN_ERROR = 'LOGIN_ERROR';

export const IMAGE_UPLOAD = 'IMAGE_UPLOAD';

export function authenticate(data) {
  return {
    type: AUTHENTICATE,
    data
  }
};

export function loginError(data) {
  return {
    type: LOGIN_ERROR,
    data
  }
};

export function imageUpload(data) {
  return {
    type: IMAGE_UPLOAD,
    data
  }
};

export const thunks = {
  login: (username, password) => {
    return (dispatch, getState) => {
      HelperServices.getJWTToken(username, password)
        .then(result => {
          if (result === Constants.successHttpStatusCode) {
            dispatch(authenticate(true));
          } else {
            dispatch(loginError(true));
          }
        })
        .catch(status => {
          dispatch(loginError(true));
        })
    };
  },
};
